import { useCallback, useEffect, useState } from 'react';
import { getApiLanguage, VISIME_LANGUAGE_CHANGED } from '../config/apiLanguage';
import { t, StringKey } from './strings';

export function useT() {
  const [lang, setLang] = useState(getApiLanguage);

  useEffect(() => {
    const onLang = () => setLang(getApiLanguage());
    window.addEventListener(VISIME_LANGUAGE_CHANGED, onLang);
    return () => window.removeEventListener(VISIME_LANGUAGE_CHANGED, onLang);
  }, []);

  return useCallback(
    (key: StringKey, vars?: Record<string, string | number>) => t(key, vars, lang),
    [lang]
  );
}
